import type { ReactElement } from 'react'
import { useRequiredParams } from '@util'
import type { AttachmentId, AttachmentData } from '@terros/common'
import { useAttachment } from '@front/model'
import { NotReady, Page, TButton } from '@components'
import { createFileRoute } from '@tanstack/react-router'

function EventAttachment(): ReactElement {
  const { attachmentId } = useRequiredParams<{ attachmentId: AttachmentId }>()
  const { data, isLoading, error } = useAttachment(attachmentId)

  if (isLoading || error || !data) return <NotReady data={data} error={error} id='Attachment' isLoading={isLoading} />

  return (
    <Page>
      <Page.Heading title={`Attachment: ${data.filename}`}>
        <TButton icon='open_in_new' component='a' target='_blank' href={data.downloadUrl} variant='secondary'>
          Open
        </TButton>
      </Page.Heading>
      <AttachmentContent attachment={data} />
    </Page>
  )
}

const AttachmentContent = ({ attachment }: { attachment: AttachmentData }): ReactElement => {
  if (attachment.contentType.startsWith('image/svg')) {
  } else if (attachment.contentType.startsWith('image/')) {
    return <img alt={attachment.filename} src={attachment.downloadUrl} />
  } else if (attachment.contentType === 'application/pdf') {
    return <iframe referrerPolicy='no-referrer' className='h-full' src={attachment.downloadUrl} />
  }
  return <NotReady error='This file cannot be displayed. Download the file to view it.' />
}

export const Route = createFileRoute('/attachment/$attachmentId/')({
  component: EventAttachment,
})
